import {connect} from 'react-redux'

import {adProductSelector} from 'data/redux/selectors/productSelector';
import {PRODUCT_STATUS_ORDER_APPROVED_WAITING_TRANSFER} from 'data/redux/constants/productsConstants';
import ApproveButton
  from 'gui/pages/mainRouter/pages/ad/components/commons/adControlTopLine/components/approveDenyButtons/components/approveButton';
import {getUpdateProductActionCreator} from 'data/redux/actions/productsActions';

const mapStateToProps = (state, {product}) => {
  return {
    product: product || adProductSelector(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    approve: (id) => dispatch(getUpdateProductActionCreator({
      id,
      status: PRODUCT_STATUS_ORDER_APPROVED_WAITING_TRANSFER
    })),
  };
};

const ApproveButtonContainer = connect(mapStateToProps, mapDispatchToProps)(ApproveButton as any) as any;

export default ApproveButtonContainer;
